import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const tableStyles = makeStyles((theme: Theme) => ({
  table: {
    backgroundColor: '#ffffff',
    fontFamily: theme.typography.body1.fontFamily,
    fontSize: theme.typography.body1.fontSize,
  },

  margin: {
    marginBottom: theme.spacing(2),
  },

  thead: {
    backgroundColor: '#3D8FBF',
    color: '#ffffff',
  },
  tr: {
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
    '&:focus-within': {
      backgroundColor: theme.palette.grey[200],
    },
  },
  cellPadding: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 3,
    paddingRight: 3,
  },
  cellIconPadding: {
    paddingRight: 0,
  },
  editCellPadding: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
  tableBorder: {
    borderCollapse: 'separate',
    borderWidth: 0,
    borderStyle: 'solid',
    borderColor: '#A0A0A0',
  },
  textFilterCell: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  BorderLeft: {
    borderLeftWidth: 1,
  },
  BorderRight: {
    borderRightWidth: 1,
  },
  BorderBottom: {
    borderBottomWidth: 1,
  },
  BorderTop: {
    borderTopWidth: 1,
  },
  BorderLeftBold: {
    borderLeftWidth: '2px !important',
  },
  BorderRightBold: {
    borderRightWidth: 2,
  },
  BorderBottomBold: {
    borderBottomWidth: 2,
  },
  BorderTopBold: {
    borderTopWidth: 2,
  },
  fit: {
    whiteSpace: 'nowrap',
    width: '1%',
  },

  splittHeadRow21: {
    paddingBottom: 0,
  },
  splittHeadRow22: {
    paddingTop: 0,
    paddingLeft: 1,
    paddingRight: 1,
  },

  stickyTable: {
    position: 'relative',
  },

  numberWidth: {
    minWidth: 70,
  },

  totalCell: {
    fontWeight: 'bold',
  },

  fullWith: {
    width: '100%',
  },

  clickable: {
    cursor: 'pointer',
  },

  stickyThead: {
    /*
    position: 'sticky',
    top: 50,
    zIndex: 5,
     Don't forget this, required for the stickiness */
  },
  stickyRowColor: {
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
      /* nog niet helemaal goed, als de TR hover heeft, moet mijn kleur ook veranderen */
    },
  },

  stickyTester: {
    //backgroundColor: '#ff0000',
  },

  divTable: {
    display: 'table',
  },
  divTableRow: {
    display: 'table-row',
  },
  divTableHead: {
    /*
    border: '1px solid #999999',
    padding: '3px 10px',
    */
    display: 'table-cell',
  },
  divTableCell: {
    /*
    border: '1px solid #999999',
    padding: '3px 10px',
    */
    display: 'table-cell',
  },
  divTableHeading: {
    /*
    backgroundColor: '#EEE',
    fontWeight: 'bold',
    */
    display: 'table-header-group',
  },
  divTableFoot: {
    /*
    backgroundColor: '#EEE',
    fontWeight: 'bold',
    */
    display: 'table-footer-group',
  },
  divTableBody: {
    display: 'table-row-group',
  },
}));
